import e from "@dialpad/dialtone-tokens/layered/themes/tokens-autumn-colors.css?inline";
//#region themes/autumn.js
var t = {
	brand: {
		css: e,
		name: "autumn"
	},
	material: { name: "sandstone" }
};
//#endregion
export { t as default };
